<div class="SLV2-shorts-video-card">
    <div class="SLV2-shorts-video-thumb">
        <button class="SLV2-shorts-play-btn">
            <img src="selflearnv2-ui/assets/img/shorts-play-icon.svg"/>
        </button>
        <img src='{{displayImage(videoData.thumbnailURL)}}'/>
    </div>
    <div class="SLV2-shorts-video-content-area">
        <h4 class="SLV2-shorts-video-title">{{cardTitle}}</h4>
        <div class="SLV2-shorts-video-info-row">
            <div class="SLV2-shorts-video-info">
                <span>{{noOfViews}} views</span>
            </div>
        </div>
    </div>

</div>
